/**
 * Все оверлеи попадают в конец body в момент открытия: q-dialog — через портал
 * Quasar (createGlobalNode → body.appendChild), дропдауны и селекты — через
 * <Teleport to="body">. Значит последний совпавший в порядке DOM и есть верхний.
 *
 * Hover-дропдауны исключены намеренно: они открываются от наведения мыши и
 * ничего не ждут от клавиатуры, но, всплыв поверх открытого подтверждения,
 * иначе перехватывали бы у него звание верхнего оверлея и глушили ESC/Enter.
 * У .mosta-context-menu такого класса-маркера нет, поэтому hover-варианты этого
 * меню (они есть только в Analytics) в теории могут перехватить верхний уровень
 * у открытого подтверждения — на страницах с подтверждениями они не встречаются.
 *
 * .fmenu (меню инлайн-редактирования поля) в body не телепортируется, когда у
 * InlineDescriptor не выставлен moveToBody, но тогда он лежит внутри своего
 * оверлея-родителя и в порядке DOM всё равно идёт после него. А открытый на самой
 * странице .fmenu звание верхнего ни у кого не отнимает: диалог Quasar
 * добавляется в конец body, то есть заведомо после разметки страницы.
 */
const OVERLAY_SELECTOR =
    ".q-dialog, .dropdown-content:not(.dropdown-content--hover), .app-select__dropdown, .mosta-context-menu, .fmenu";

/**
 * Лежит ли элемент в самом верхнем открытом оверлее. Так вложенные модалки,
 * дропдауны и селекты разбираются, чей сейчас Escape.
 */
export function isTopmostOverlay(el: HTMLElement | null): boolean {
    if (!el) {
        return false;
    }
    const overlays = document.querySelectorAll(OVERLAY_SELECTOR);
    const top = overlays[overlays.length - 1];
    return !!top && top.contains(el);
}
